// extracted by mini-css-extract-plugin
export default {"container":"BboIF6y9DD65YpyEFRRC"};